import React from "react";
import { JhText } from "designPackages/textPackage";
import { Crown, Rocket, CheckCircle, Clock, PlusCircle } from "lucide-react";

interface CustomTagProps {
  tag: any;
}

const CustomTag: React.FC<CustomTagProps> = ({ tag }) => {
  // Icon mapping
  const getIcon = (iconName: string, iconType: string, iconColor?: string) => {
    if (iconType === "static") {
      // Return an image element for static icons
      return <img src={iconName} alt={tag.value} className="w-3 h-3" />;
    }

    // Special case for circle/dot icon used in status tags
    if (iconName === "circle" && iconColor) {
      return <div style={{ backgroundColor: iconColor }} className={`w-2 h-2 rounded-full`}></div>;
    }

    // Otherwise render a Lucide icon
    switch (iconName) {
      case "crown":
        return <Crown size={12} />;
      case "rocket":
        return <Rocket size={12} color="#4F46E5" />;
      case "check-circle":
        return <CheckCircle size={12} />;
      case "clock":
        return <Clock size={12} />;
      case "plus-circle":
        return <PlusCircle size={12} />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`px-2.5 py-1 rounded-full flex items-center gap-2 border border-solid border-border bg-muted`}
    >
      {getIcon(tag.icon, tag.iconType || "lucide", tag.iconColor)}
      <JhText variant="caption2" style={{ color: tag.textColor }}>
        {tag.value}
      </JhText>
    </div>
  );
};

export default CustomTag; 